import { createBaseThemeSettings, createPalette } from '@hmhco/base-theme';
import { createTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import colours from './nweaThemeColours.json';

const nweaPaletteOverrides = {
  // this extra color needed for Alert component neutal variant
  neutral: {
    main: '#ffffff',
    light: '#ffffff',
  },
};

export default createTheme(
  createBaseThemeSettings({
    palette: deepmerge(createPalette(colours), nweaPaletteOverrides),
  }),
);
